<template>
    <div>
		<div class="page-filter-box">
		    <el-row :gutter="20">		  
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                        </el-select>
                    </el-input>
                </el-col>	       	        
		        <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="4" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		        </el-col>
		    </el-row>
		</div>
        <div class="page-btns-box">
            <el-button  type="primary" size="small" @click="$refs.details.show()" icon="el-icon-plus">新建</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" :min-width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="status" label="看现场入口" min-width="100">
					<template slot-scope="scope">
						<p>演出详情页：<span :class="scope.row.openActivityDetail == 1 ? 'color-success' : 'color-danger'">{{scope.row.openActivityDetail == 1 ? '开启' : '关闭'}}</span></p>
						<p>购票成功页：<span :class="scope.row.openBuySuccess == 1 ? 'color-success' : 'color-danger'">{{scope.row.openBuySuccess == 1 ? '开启' : '关闭'}}</span></p>
						<p>订单详情页：<span :class="scope.row.openOrderDetail == 1 ? 'color-success' : 'color-danger'">{{scope.row.openOrderDetail == 1 ? '开启' : '关闭'}}</span></p>
						<p>票夹入口：<span :class="scope.row.openWallet == 1 ? 'color-success' : 'color-danger'">{{scope.row.openWallet == 1 ? '开启' : '关闭'}}</span></p>
					</template>
				</el-table-column>
                <el-table-column label="列表PV" prop="pv"></el-table-column>
                <el-table-column prop="uv" label="列表UV" ></el-table-column>
                <el-table-column prop="declareNum" label="发布人数" ></el-table-column>                
				<el-table-column prop="status" label="列表状态">
					<template slot-scope="scope">
						{{scope.row.status == 1 ? '开启' : '隐藏'}}
					</template>
				</el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
				<el-table-column prop="createUserName" label="创建人"></el-table-column>
                <el-table-column fixed="right" label="操作" :width="180">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="action(scope.row)" icon="el-icon-view" >
							{{scope.row.status == 1 ? '隐藏' : '开启'}}
						</el-button>
						<el-button type="text" size="small" @click="$refs.dataView.show(scope.row.id)" icon="el-icon-tickets" >数据</el-button>
						<el-button type="text" size="small" @click="$refs.details.show(scope.row)" icon="el-icon-edit" >管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
       <Details ref="details" @onUpdate="getDataList"></Details>
       <DataView ref="dataView" @onUpdate="getDataList"></DataView>
    </div>
</template>

<script>
import Details from './components/details.vue'
import DataView from './components/dataView';

const defaultQuery = {
    pageNo: 1,   
    searchType: 1,
    searchValue: ""
};

export default {
    components:{Details,DataView},
    data(){
        return {
            data: [],
            dataList: [],
            params:{
                ...defaultQuery,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            this.listLoading = true;
            const res = await this.$request({
                url: '/watchTogether/pageList',
                method: 'post',
                data: this.params,
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
        },
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.getDataList();
		},
		//重置搜索
		reset() {
		    this.params = {
		        ...defaultQuery,
		        pageSize: this.params.pageSize,
		    };
		    this.getDataList();
		},
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
		action(data){
			console.log(data)
			
			this.$confirm(`确认要${data.status === 0 ? '开启' : '隐藏'}吗？`, '隐藏/开启', {
			    type: 'warning',
			    center: true,
			    closeOnClickModal: false
			}).then(async () => {
				if( data.status == 0 ){
					data.status = 1
				}else{
					data.status = 0
				}
			    const response = await this.$request({
			        url: "/watchTogether/edit",
			        method: "POST",
			        data,
			    });
			    const {msg, state} = response.data;
			    if (state != 1) return this.$message.error(msg);
			    this.$message.success('操作成功');
			    
			}).catch(() => {
				
		    })
		},
        // 管理
        manage(row) {
            const {id} = row;
            this.$refs.messagePushDetail.show(id);
        }
    }
}
</script>